import { handleAddOnInControlBar, handleConnectedProductsInControlBar, updateColor, updateQuantity, updateSetSizeInControlBar } from '../components/control-bar'
import AddButton from '../components/add-button-state'
import { listenForVariantOptionsChanges } from '@surf-turf/nemo/assets/utils-events'

class ControlBar extends HTMLElement {
  constructor() {
    super()

    /**
     * Handle update control bar.
     */
    const handleUpdateControlBar = () => {
      // Set selected connected products in the control bar.
      handleConnectedProductsInControlBar()

      // Set the selected main product in the control bar.
      handleAddOnInControlBar()

      // Update size in control bar.
      updateSetSizeInControlBar()

      // Update the color in the control bar.
      updateColor()

      // Update the quantity in the control bar.
      updateQuantity()
    }

    /**
     * Handle update add to bag.
     */
    const handleUpdateAddToBag = () => {
      // Update the add to bag button price.
      AddButton.updatePrice()
    }

    // Initial setting of the control bar and the add to bag button.
    handleUpdateControlBar()
    handleUpdateAddToBag()

    /**
     * Listen for variant options changes.
     */
    listenForVariantOptionsChanges(() => {
      handleUpdateControlBar()
      handleUpdateAddToBag()
    })
  }
}

// Check if element is defined, if not define it..
// eslint-disable-next-line no-undefined
if (customElements.get('control-bar') === undefined) {
  customElements.define('control-bar', ControlBar)
}
